import React, { Component } from "react";

import Alert from "@cloudscape-design/components/alert";
import Badge from "@cloudscape-design/components/badge";
import Box from "@cloudscape-design/components/box";
import Container from "@cloudscape-design/components/container";
import Header from "@cloudscape-design/components/header";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Spinner from "@cloudscape-design/components/spinner";

class PlayerProfilePartnerStatsSection extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loaded: false,
			stats: null,
			error: null,
		};

		this.unmounted = false;
		this.loadRequestId = 0;
	}

	componentDidMount() {
		this.loadPartnerStats();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.uid !== this.props.uid || prevProps.project !== this.props.project || prevProps.user !== this.props.user) {
			this.loadPartnerStats();
		}
	}

	componentWillUnmount() {
		this.unmounted = true;
		this.loadRequestId += 1;
	}

	canViewPartnerStats() {
		const showColumn = Array.isArray(this.props.user?.showColumn) ? this.props.user.showColumn : [];

		return this.props.user?.level >= 6 || (showColumn.includes("deposits") && showColumn.includes("withdrawals"));
	}

	loadPartnerStats() {
		if (!this.canViewPartnerStats() || !this.props.uid) {
			return;
		}

		const requestId = ++this.loadRequestId;
		const requestUid = this.props.uid;
		const requestProject = this.props.project;

		this.setState({
			loaded: false,
			stats: null,
			error: null,
		});

		this.props.Interface.request(
			"get",
			{ class: "users", module: "data", method: "getPartnerStats" },
			{
				uid: requestUid,
				project: requestProject,
			},
		)
			.then((stats) => {
				if (this.unmounted || requestId !== this.loadRequestId || requestUid !== this.props.uid || String(requestProject || 0) !== String(this.props.project || 0)) return;

				this.setState({
					loaded: true,
					stats: stats || null,
					error: null,
				});
			})
			.catch((error) => {
				if (this.unmounted || requestId !== this.loadRequestId || requestUid !== this.props.uid || String(requestProject || 0) !== String(this.props.project || 0)) return;

				this.setState({
					loaded: true,
					stats: null,
					error,
				});
			});
	}

	formatMoney(value, divideByHundred = false) {
		const number = Number(value) || 0;
		const formattedValue = divideByHundred ? number / 100 : number;

		return `${new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(formattedValue)} RUB.`;
	}

	formatCount(value) {
		return new Intl.NumberFormat("en-US").format(Number(value) || 0);
	}

	formatPercent(value) {
		return `${new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(Number(value) || 0)}%`;
	}

	renderMetric(label, value, color = "dark") {
		return (
			<SpaceBetween direction="horizontal" size="s">
				<Box variant="span">
					<b>{label}</b>
				</Box>
				<Badge color={color}>{value}</Badge>
			</SpaceBetween>
		);
	}

	render() {
		if (!this.canViewPartnerStats()) {
			return null;
		}

		const { loaded, stats, error } = this.state;

		return (
			<Box margin={{ top: "m" }}>
				<Container
					header={
						<Header variant="h3" description="Aggregated referral metrics for this partner">
							Partner Stats
						</Header>
					}>
					{!loaded ? (
						<Spinner size="normal" />
					) : error || !stats ? (
						<Alert type="info">No partner stats</Alert>
					) : (
						<SpaceBetween size="s" direction="vertical">
							{this.renderMetric("Referral deposits", this.formatMoney(stats.referralDepositsTotal), "green")}
							{this.renderMetric("Referral withdrawals", this.formatMoney(stats.referralWithdrawalsTotal), "red")}
							{this.renderMetric("Partner referral profit", this.formatMoney(stats.partnerReferralProfit, true), "blue")}
							{this.renderMetric("Referral FTD", this.formatCount(stats.referralFtdCount), "grey")}
							{this.renderMetric("FTD rejected", this.formatCount(stats.rejectedFtdCount), "red")}
							{this.renderMetric("Average deposit", this.formatMoney(stats.referralAverageDeposit), "green")}
							{/* {this.renderMetric("Referral clicks", this.formatCount(stats.referralClicksCount), "grey")} */}
							{/* {this.renderMetric("Referral registrations", this.formatCount(stats.referralRegistrationsCount), "grey")} */}
							{this.renderMetric("Click / Reg conversion", this.formatPercent(stats.clickToRegistrationConversion), "blue")}
							{this.renderMetric("Reg / FTD conversion", this.formatPercent(stats.registrationToFtdConversion), "blue")}
						</SpaceBetween>
					)}
				</Container>
			</Box>
		);
	}
}

export default PlayerProfilePartnerStatsSection;
